import script from "./InpSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./InpSearch.vue?vue&type=script&setup=true&lang=js"

import "./InpSearch.vue?vue&type=style&index=0&id=dc0660aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc0660aa"]])

export default __exports__